import { usingGet } from '@ocean/api'

export const getDictionaries = () => usingGet('References', { useProxy: true })
